import { createUseCart } from "@decocms/apps-vtex/hooks/createUseCart";
import { invoke } from "~/server/invoke";

export type { OrderForm, OrderFormItem } from "@decocms/apps-vtex/types";

export const { useCart, resetCart, itemToAnalyticsItem } = createUseCart({
  invoke,
});
